import { InputNumberLocalized } from '@components'

import { ReactElement } from 'react'

import { AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS } from '../../constants/automaticPaymentRemindersMaxDays'
import { AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS } from '../../constants/automaticPaymentRemindersMinDays'
import { useAutomaticPaymentRemindersModalForm } from '../../contexts/automaticPaymentRemindersModalFormContext'
import * as Styled from './styles'

export const AutomaticPaymentRemindersDaysSelect = (): ReactElement => {
  const { automaticPaymentRemindersModalForm } = useAutomaticPaymentRemindersModalForm()
  const { FormItem } = automaticPaymentRemindersModalForm

  return (
    <Styled.AutomaticPaymentRemindersDaysSelectWrapper>
      <FormItem
        name="nDays"
        render={({ field: { onChange, value, ...props } }) => {
          const roundedValue = Math.round(Number(value))
          return (
            <InputNumberLocalized
              {...props}
              keyboard
              onChange={(value) => {
                onChange(Math.round(value))
              }}
              max={AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS}
              min={AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS}
              value={roundedValue}
              withFormatting={false}
            />
          )
        }}
      />
    </Styled.AutomaticPaymentRemindersDaysSelectWrapper>
  )
}
